import Checkbox from '@gameday/react-components/components/Checkbox'
import { FormLink } from '@gameday/react-components/components/Link'
import { Modal } from '@gameday/react-components/components/Modal'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import ToolTip from '../../../components/form/Common/ToolTip'
import { sanitizeRichText } from '../../../functions/richText'
import styles from '../../styles.module.scss'

const StyledTnC = styled.div`
  .MuiCheckbox-colorPrimary.Mui-checked,
  .MuiIconButton-colorPrimary {
    color: var(--custom-primary-color);
  }
`

function Component({
  onChange = () => {},
  onBlur = () => {},
  value,
  label,
  helpText,
  isMandatory,
  description,
  errorText,
  name,
  id,
}) {
  const [showMore, setShowMore] = useState(false)
  const [modalState, setModalState] = useState({
    description: '',
    name: '',
    showModal: false,
  })
  let tacRef = null
  useEffect(() => {
    const shouldShowMore = tacRef.offsetHeight > tacRef.parentElement.clientHeight
    setShowMore(shouldShowMore)
  }, [description])
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    // biome-ignore lint/a11y/noLabelWithoutControl: TODO
    <label>
      <StyledTnC className={styles.termsWrapper}>
        <Checkbox
          style={{ marginTop: -5 }}
          onBlur={onBlur}
          isChecked={!!value}
          isRequired={isMandatory}
          onChecked={value => onChange(value)}
          name={name}
          id={`${id}-checkbox`}
        />
        <div>
          <div className={styles.termsAndConditionContainer}>
            {label && (
              <div className={styles.termsAndConditionName}>
                {label} {isMandatory ? <span className={styles.required}> *</span> : null}
                {helpText && <ToolTip text={helpText} />}
              </div>
            )}
            <div className={showMore ? styles.tacDescriptionContainer__cover : styles.tacDescriptionContainer}>
              <div
                ref={el => (tacRef = el)}
                // biome-ignore lint/security/noDangerouslySetInnerHtml: TODO
                dangerouslySetInnerHTML={{
                  __html: sanitizeRichText(description),
                }}
              />
            </div>
          </div>
          {showMore && (
            <FormLink
              style={{ marginTop: 10 }}
              onClick={() =>
                setModalState({
                  description,
                  label,
                  showModal: !modalState.showModal,
                })
              }
            >
              View more...
            </FormLink>
          )}
          {errorText && <div className={styles.customErrorText}>{errorText}</div>}
        </div>
        <Modal
          label={modalState.label}
          isShowSaveButton
          isShowBottomBar
          isOpen={modalState.showModal}
          handleModalClose={() =>
            setModalState({
              showModal: !modalState.showModal,
            })
          }
          handleModalSubmit={() =>
            setModalState({
              showModal: !modalState.showModal,
            })
          }
          isSubmitWithOutClose={false}
          isHideCancel
          midWidthPopup
          fullScreen={false}
          fullWidth
          titleBottomBorder
          isError={false}
          okText="Close"
        >
          <div
            // biome-ignore lint/security/noDangerouslySetInnerHtml: TODO
            dangerouslySetInnerHTML={{
              __html: sanitizeRichText(modalState.description),
            }}
          />
        </Modal>
      </StyledTnC>
    </label>
  )
}

export default Component
